import { AxiosResponse } from 'axios'

import { NP_AVAILABLE_TIMES_PATH } from '@lyrahealth-inc/shared-app-logic/src/features/npTesting/constants'
import {
  NpAvailableTimesRequest,
  NpAvailableTimesResponse,
} from '@lyrahealth-inc/shared-app-logic/src/models/calendar/CalendarV2'

import { axiosInstance } from '../axiosInstance'

export const postNpAvailableTimes = (
  request: NpAvailableTimesRequest,
): Promise<AxiosResponse<NpAvailableTimesResponse>> => {
  return axiosInstance.post(NP_AVAILABLE_TIMES_PATH, request)
}
